import React, { useMemo } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { AuthContext } from '../../hooks/useAuthContext';

const Auth = (props: React.PropsWithChildren<{}>) => {
  const { userData, pending, loaded, authorized, fetchUserData, features, fetchFeatures } = useAuth();
  const userDataContext = useMemo(() => {
    const disableRatingMechanics = features.includes('ratingMechanics') ? false : true;
    const enabledFunctionalLiteracyTasks = features.includes('functionalLiteracy') ? true : false;
    const enabledSafeTerritoryTasks = features.includes('safeTerritory') ? true : false;
    const enabledInfoKpk = features.includes('kpkMainPage') ? true : false;
    const showVectorSurvey = features.includes('showVectorSurvey');
    const allowAutoOpenVectorSurvey = features.includes('allowAutoOpenVectorSurvey');

    return {
      userData,
      pending,
      loaded,
      authorized,
      fetchUserData,
      fetchFeatures,
      azTests: {
        disableRatingMechanics,
        enabledFunctionalLiteracyTasks,
        enabledSafeTerritoryTasks,
        enabledInfoKpk,
        showVectorSurvey,
        allowAutoOpenVectorSurvey,
      },
    };
  }, [userData, fetchUserData, pending, loaded, authorized, fetchFeatures, features]);

  return <AuthContext.Provider value={userDataContext}>{props.children}</AuthContext.Provider>;
};

export default Auth;
